import { GraphQLClient } from 'graphql-hooks';
import { resetSessionToDefault } from './features/data/session';
import { SubscriptionClient } from 'subscriptions-transport-ws';
import cogoToast from 'cogo-toast';

const resolveSocketUrl = () => {
  const protocol = window.location.protocol === 'https:' ? 'wss://' : 'ws://';
  return protocol + window.location.host + '/subscriptions';
};

export const subscriptionClient = new SubscriptionClient(resolveSocketUrl(), {
  reconnect: true,
  inactivityTimeout: 0,
  lazy: true
});

export const client = new GraphQLClient({
  url: '/graphql',
  credentials: 'same-origin',
  fetchOptions: {
    keepalive: true
  },
  headers: { 'Accept-Language': 'en' },
  onError: ({ operation, result }) => {
    if (result.error && result.error.graphQLErrors) {
      const error = result.error.graphQLErrors[0];
      if (error.code === '403') {
        resetSessionToDefault();
        window.location.reload();
      } else if (error.code === 'MISSING_PERMISSION') {
        cogoToast.error(error.message);
      }
    }
  },
  subscriptionClient: () => subscriptionClient
});
